import { trackException } from './exceptionTracker';
import { resolveListgenUserID } from './resolveListgenUserID';

export const logAuthException = ({ module, code, error, data = {}, level = 'error' }) => {
  const resolvedId = resolveListgenUserID();

  trackException({
    module,
    code,
    error,
    data,
    level,
    listgenUserID: resolvedId || 'anonymous',
    isValidLogin: false,
    isValidSemiAuth: false,
    hasUserData: Boolean(resolvedId),
  });
};
